export const mapLanguage = (languageCode?: string, language?: string) => {
    return {
        languageData: {
            current: language,
            currentKey: languageCode || ''
        }
    };
};
